export class HallResearchSc {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '3.30';
        this.volume = 50;
        this.volumeMute = false;
        this.videoOutput = '1';
        this.power = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /ST/i,
                callback: (match) => {
                    this.socket.send(`FW: ${this.firmwareVersion}`);
                },
            },
            {
                name: 'getPower',
                regExp: /R POWER/i,
                callback: (match) => {
                    this.socket.send(`POWER ${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /R SOURCE/i,
                callback: (match) => {
                    this.socket.send(`SOURCE ${this.videoOutput}`);
                },
            },
            {
                name: 'setRoute',
                regExp: /S SOURCE (\d+)/i,
                callback: (match) => {
                    this.videoOutput = match[1];
                    this.socket.send(`S SOURCE ${this.videoOutput}`);
                },
            },
            {
                name: 'setPower',
                regExp: /S POWER (\d+)/i,
                callback: (match) => {
                    this.power = match[1] === '1' ? true : false;
                    this.socket.send(`POWER ${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'setVolume',
                regExp: /S VOLUME (\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`S VOLUME ${this.volume}`);
                },
            },
            {
                name: 'getVolume',
                regExp: /R VOLUME/i,
                callback: (match) => {
                    this.socket.send(`VOLUME ${this.volume}`);
                },
            },
            {
                name: 'setVolumeMute',
                regExp: /S AUDIO MUTE (\d+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '1' ? true : false;
                    this.socket.send(`S AUDIO MUTE ${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'getVolumeMute',
                regExp: /R AUDIO Mute/i,
                callback: (match) => {
                    this.socket.send(`AUDIO MUTE ${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Invalid Command`);
                },
            },
        ];
    }
}
HallResearchSc.emulatorType = 'socketEmulator';
HallResearchSc.key = '-LStmN9BU56TIkMbOC_u';
